import React, { useState, useEffect } from "react";
import styles from "./HeroCarousel.module.css";
import { useNavigate } from "react-router-dom";

interface Slide {
  title: string;
  subtitle: string;
  background: string;
}

interface HeroCarouselProps {
  slides: Slide[];
}

const HeroCarousel: React.FC<HeroCarouselProps> = ({ slides }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  if (slides.length === 0) return null;

  return (
    <div
      className={styles.heroSection}
      style={{
        backgroundImage: `linear-gradient(rgba(26, 26, 46, 0.7), rgba(26, 26, 46, 0.7)), url(${slides[currentSlide].background})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className={styles.heroContent}>
        <h1 className={styles.heroTitle}>{slides[currentSlide].title}</h1>
        <p className={styles.heroSubtitle}>{slides[currentSlide].subtitle}</p>
        <button
          className={styles.ctaButton}
          onClick={() => navigate(`/gallery`)}
        >
          Explore Collections
          <span className={styles.arrow}>&rarr;</span>
        </button>
      </div>

      <div className={styles.dotsContainer}>
        {slides.map((_, index) => (
          <span
            key={index}
            className={`${styles.dot} ${
              currentSlide === index ? styles.activeDot : ""
            }`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default HeroCarousel;
